import {Graphics, InteractionEvent} from 'pixi.js';
import {StaticData} from '../../../../../../../data/StaticData';
import {SizesSelectorButtonEvents} from './SizesSelectorButtonEvents';
import {HoverableObject} from '../../../../../../../base/HoverableObject';

export class SizesSelectorButton extends HoverableObject
{
    graphicsBg: Graphics;
    graphicsPoint: Graphics;

    constructor(private playerId: string, public index: number) {
        super();

        this.graphicsBg = new Graphics();

        this.graphicsPoint = new Graphics();
        this.graphicsPoint.beginFill(0xffffff);
        let innerSize: number = StaticData.videoSeatScalesButtonPointsSizes[this.index];
        this.graphicsPoint.drawRoundedRect(-innerSize / 2, -innerSize / 2, innerSize, innerSize, 4);
        this.graphicsPoint.endFill();

        this.graphicsBg.interactive = this.graphicsBg.interactiveChildren = true;
        this.graphicsPoint.interactive = this.graphicsPoint.interactiveChildren = false;

        this.addChild(this.graphicsBg);
        this.addChild(this.graphicsPoint);

        this.selected = false;

        this.graphicsBg.on('pointerdown', this.onPointerDown, this);
    }

    private _selected: boolean = false;

    get selected(): boolean {
        return this._selected;
    }

    set selected(value: boolean) {

        this._selected = value;
        this.graphicsBg.clear();
        this.graphicsBg.beginFill(value ? 0xF65A00 : 0x25282D);
        this.graphicsBg.drawRoundedRect(
            -StaticData.videoSeatScalesButtonSize / 2,
            -StaticData.videoSeatScalesButtonSize / 2,
            StaticData.videoSeatScalesButtonSize,
            StaticData.videoSeatScalesButtonSize,
            9
        );
        this.graphicsBg.endFill();
        this.graphicsPoint.alpha = value ? StaticData.videoSeatScalesButtonPointAlphaSelected : StaticData.videoSeatScalesButtonPointAlphaUnselected;
    }

    /**
     * Обработчик события pointerover
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOver(e: InteractionEvent): void {
        if (this._selected) {
            return;
        }
        this.graphicsPoint.alpha = StaticData.videoSeatScalesButtonPointAlphaSelected;
    }

    /**
     * Обработчик события pointerout
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOut(e: InteractionEvent): void {
        if (this._selected) {
            return;
        }
        this.graphicsPoint.alpha = StaticData.videoSeatScalesButtonPointAlphaUnselected;
    }

    destroy(): void {
        this.graphicsBg.off('pointerDown', this.onPointerDown, this);

        super.destroy();
    }

    onPointerDown(e: InteractionEvent): void {
        dispatchEvent(new MessageEvent(SizesSelectorButtonEvents.SELECTED, {
            data: {
                playerId: this.playerId,
                index: this.index
            }
        }));
    }
}
